module.exports = __webpack_public_path__ + "img/106.9.96e1d7c4.png";